import { CommonModule } from '@angular/common'; 
import { Component, signal, inject, computed, input} from '@angular/core';
import { SensorListCard } from '../sensor-list-card/sensor-list-card';
import { SensorGroupType } from 'libs/domain/sensor/sensor.enums';
import { BadgeComponent } from 'libs/shared/components/ui/badge/badge.component';
import { Sensor } from 'libs/domain/sensor/sensor-interfaces';
import { SensorUIService } from 'libs/features/sensors/services/sensor-ui.service';

@Component({
  selector: 'lib-sensor-list',
  templateUrl: './sensor-list.component.html',
  standalone: true,
  imports: [CommonModule, SensorListCard, BadgeComponent],
})
export class SensorList {

  sensors = input<Sensor[] | undefined>();

  private sensorUIService = inject(SensorUIService);

  sensorGroupType = signal(SensorGroupType);

  //Agrupa els elements de la llista per parentId
  readonly sensorGroups = computed(() => {
    if (!this.sensors()) return [];
    const arr = this.sensors()!;
    const groups: Array<{ id: number | null; name: string | null, type: SensorGroupType | null, items: Sensor[] }> = [];

    for (const s of arr) {
      const pid = s.groupId ?? null;
      const pname = s.groupName ?? null;
      const ptype = s.groupType ?? null;
      const last = groups[groups.length - 1];

      if ((!last || last.type !== ptype) || (!last || last.id !== pid)) {
        groups.push({ id: pid, name: pname, type: ptype, items: [s] });
      } else {
        last.items.push(s);
      }
    }

    return groups;
  }); 

  groupBadgeUi(groupType: SensorGroupType | null) {
    return this.sensorUIService.getSensorGroupRecord(groupType);
  }
}